<template>
  <div
    :class="boxClass"
    :style="customStyles">
    <div :class="titleClass">
      {{ title }}
    </div>

    <div :class="messageClass">
      {{ message }}
    </div>
  </div>
</template>

<script>
export default {
  props: {
    type: {
      type: String,
      default: 'error',
      validator: function (value) {
        return ['info', 'success', 'warning', 'error'].indexOf(value) !== -1
      }
    },
    title: {
      type: String,
      requidanger: false
    },
    message: {
      type: String
    },
    customStyles: {
      type: Object
    }
  },

  computed: {
    isInfo () {
      return this.type === 'info'
    },

    isSuccess () {
      return this.type === 'success'
    },

    isWarning () {
      return this.type === 'warning'
    },

    isError () {
      return this.type === 'error'
    },

    boxClass () {
      return ['overflow-y-auto', 'scrolling-touch', 'rounded', 'px-3', 'py-2', {
        'bg-info-90': this.isInfo && !this.customStyles,
        'bg-success-90': this.isSuccess && !this.customStyles,
        'bg-warning-90': this.isWarning && !this.customStyles,
        'bg-danger-90': this.isError && !this.customStyles
      }]
    },

    titleClass () {
      return ['text-lg', 'font-bold', {
        'text-info-30': this.isInfo && !this.customStyles,
        'text-success-30': this.isSuccess && !this.customStyles,
        'text-warning-30': this.isWarning && !this.customStyles,
        'text-danger-30': this.isError && !this.customStyles
      }]
    },

    messageClass () {
      return ['font-medium', {
        'text-info-20': this.isInfo && !this.customStyles,
        'text-success-20': this.isSuccess && !this.customStyles,
        'text-warning-20': this.isWarning && !this.customStyles,
        'text-danger-20': this.isError && !this.customStyles
      }]
    }
  }
}
</script>
